// Search Input Component
// Main search/chat input with send button and optional template dropdown

import React, { useState, useEffect } from "react";
import { logger } from "../../../core";
import DropdownSelect from "../../../components/DropdownSelect";

export function SearchInput({ onSubmit, initialValue = "", templateOptions = [], selectedTemplate = "", onTemplateChange }) {
  const inputRef = React.useRef(null);
  const [inputValue, setInputValue] = useState(initialValue);
  const lastInitialValueRef = React.useRef(initialValue);

  // Update input when initialValue changes (after auth redirect)
  useEffect(() => {
    if (initialValue && initialValue !== lastInitialValueRef.current) {
      setInputValue(initialValue);
      lastInitialValueRef.current = initialValue;
      logger.log(
        {
          tags: "main|search-input|payload-restored",
          color1: "green",
        },
        "Restored message after auth:",
        initialValue
      );
    }
  }, [initialValue]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e.target.value);
    }
  };

  const handleSendClick = (e) => {
    if (inputRef.current) {
      handleSubmit(inputRef.current.value);
    }
  };

  const handleSubmit = (message) => {
    const trimmedMessage = message.trim();
    if (!trimmedMessage) return;

    // Just call the parent onSubmit handler - let it handle authentication and logic
    onSubmit(trimmedMessage);
  };

  return (
    <div className="landing-input-wrapper">
      <div className="landing-input-container">
        <input
          ref={inputRef}
          type="text"
          className="landing-input"
          placeholder="Describe the app you want to make..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <button
          className="landing-send-btn"
          onClick={handleSendClick}
          disabled={!inputValue.trim()}
        >
          <i className="fa-solid fa-arrow-up"></i>
        </button>
      </div>
      {templateOptions.length > 0 && onTemplateChange && (
        <div className="landing-template-row">
          <div className="landing-template-row-inner">
            <span className="landing-template-label">
              <i className="fa-solid fa-layer-group" aria-hidden />
              Start template
            </span>
            <DropdownSelect
              id="landing-template-select"
              value={selectedTemplate}
              options={templateOptions}
              onChange={(e) => onTemplateChange(e.target.value)}
              placeholder="Select template..."
              size="md"
              preferDirection="down"
              className="landing-template-select"
            />
          </div>
        </div>
      )}
    </div>
  );
}
